export const parsePhoneFromNumToStr = (phoneNumber?: number): string => {
  if (phoneNumber) {
    return phoneNumber.toString().split('').map((number, index) => {
      if (index === 3 || index === 6) return `-${number}`
      else return number
    }).join('')
  } else return ''
}
